<form [formGroup]="filterFormGroup" id="filterForm" #filterForm ngForm>
    <p-toolbar>
        <p-floatLabel variant="on">
            <p-select
                [options]="payPeriodsSelectItems"
                formControlName="PayPeriodEndDate"
                [style]="{ 'min-width': '13em' }"
                [autoDisplayFirst]="false"
                (onChange)="PayPeriodEndDateChanged($event)"
            ></p-select>
            <label for="float-dd">Pay Period End Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <p-calendar formControlName="LaborAccrualDate"></p-calendar>
            <label for="float-dd">Labor Accrual Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on">
            <p-calendar formControlName="LeaveAccrualDate"></p-calendar>
            <label for="float-dd">Labor Reversal Date</label>
        </p-floatLabel>
    </p-toolbar>
</form>
